import React from 'react';
import {
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './ConfirmExitPopup.scss';
import { Trans } from 'react-i18next';

const ConfirmExitPopup = ({ onCancel, onClose }) => {
  return (
    <Dialog
      open
      onClose={() => onCancel()}
      maxWidth="xs"
      fullWidth
      className="confirm-dialog"
    >
      <DialogTitle>
        <span>
          <Trans>Are you sure you want to exit the current process?</Trans>
        </span>
        <IconButton
          aria-label="close"
          onClick={() => onCancel()}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          <Trans>
            Closing this window will discard all your recent changes.
          </Trans>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button
          onClick={() => onCancel()}
          variant="outlined"
          sx={{
            color: '#373a4c',
            backgroundColor: '#EBEBED',
            border: 'none',
          }}
        >
          <Trans>CANCEL</Trans>
        </Button>
        <Button
          onClick={() => onClose()}
          variant="contained"
          sx={{ backgroundColor: '#d32f2f' }}
        >
          <Trans>CLOSE</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmExitPopup;
